import { ColumnProps } from 'antd/lib/table';
import { ConsultaUsuarios } from './Responses';

export const UsuarioTableColumns: Array<ColumnProps<ConsultaUsuarios>> = [
    {
        title: 'Usuario',
        dataIndex: 'usuarioAcceso',
        key: 'usuarioAcceso',
        sorter: (a: ConsultaUsuarios, b: ConsultaUsuarios) => a.usuarioAcceso.length - b.usuarioAcceso.length,
    },
    {
        title: 'Municipio',
        dataIndex: 'municipio',
        key: 'municipio',
        sorter: (a: ConsultaUsuarios, b: ConsultaUsuarios) => a.municipio.length - b.municipio.length
    },
    {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        sorter: (a: ConsultaUsuarios, b: ConsultaUsuarios) => a.nombre.length - b.nombre.length
    },
    {
        title: 'Rol',
        dataIndex: 'rol',
        key: 'rol',
        sorter: (a: ConsultaUsuarios, b: ConsultaUsuarios) => a.rol.length - b.rol.length
    },
    {
        title: 'Correo',
        dataIndex: 'email',
        key: 'email',
        sorter: (a: ConsultaUsuarios, b: ConsultaUsuarios) => a.email.length - b.email.length
    }
];
